import { RequestMethod } from '../interfaces/typesAPI';
import Utils from '../utils/utils';
import API from './api';
export default class UserWords {
    static async getWords(userId) {
        const responseData = await API.sendRequest(Utils.buildLink(['users', userId, 'words']), RequestMethod.GET, undefined, true);
        return responseData;
    }
    static async createWord(userId, wordId, wordConfig) {
        const responseData = await API.sendRequest(Utils.buildLink(['users', userId, 'words', wordId]), RequestMethod.POST, wordConfig, true);
        return responseData;
    }
    static async getWord(userId, wordId) {
        const responseData = await API.sendRequest(Utils.buildLink(['users', userId, 'words', wordId]), RequestMethod.GET, undefined, true);
        return responseData;
    }
    static async updateWord(userId, wordId, wordConfig) {
        const responseData = await API.sendRequest(Utils.buildLink(['users', userId, 'words', wordId]), RequestMethod.PUT, wordConfig, true);
        return responseData;
    }
    static async deleteWord(userId, wordId) {
        const responseData = await API.sendRequest(Utils.buildLink(['users', userId, 'words', wordId]), RequestMethod.DELETE, undefined, true);
        return responseData;
    }
}
